import { IMAGES } from "@/site";
import { PageHero, Section, SectionTitle, BulletGrid, CTABand } from "@/components/ui-blocks/Blocks";

const TOPICS = ["Pre-trip inspection guides","School bus safety handouts","Mirror use guides","Danger zone guides","Loading and unloading guides","Railroad crossing guides","Emergency evacuation guides","Defensive driving handouts","Right turn guides","Left turn guides","Tail swing guides","Backing safety guides","Driver retraining packets","Instructor checklists","Student quizzes","Role-play scenarios","Sign-off forms","English / Spanish study sheets"];
const STYLE = ["Clear","Practical","Safety-focused","Easy to understand","Built for trainees","Useful for trainers","Designed for repetition and review"];

export default function TrainingMaterials() {
  return (
    <>
      <PageHero
        testid="materials-hero"
        eyebrow="Training Materials"
        title="Practical materials for real school bus operations."
        description="CLB Solution creates training materials written in clear, plain language so trainees can understand, practice, and apply the information."
        image={IMAGES.preTrip}
      />

      <Section testid="materials-topics">
        <SectionTitle eyebrow="Material Topics" title="From pre-trip to corrective training." />
        <BulletGrid items={TOPICS} testid="materials-topics-grid" />
      </Section>

      <Section className="bg-[#0c0c0e] border-y border-white/10" testid="materials-style">
        <SectionTitle eyebrow="Material Style" title="What every CLB Solution handout aims for." />
        <div className="grid grid-cols-2 md:grid-cols-7 gap-px bg-white/10 border border-white/10">
          {STYLE.map((s) => (
            <div key={s} className="bg-[#09090b] p-5 text-center">
              <div className="font-display text-base md:text-lg font-bold uppercase tracking-tight">{s}</div>
            </div>
          ))}
        </div>
      </Section>

      <CTABand title="Need materials for your trainees?" description="Email CLB Solution to inquire about training handouts and digital learning resources." />
    </>
  );
}
